import { Auction } from '@/api';
import BidTimer from '@/components/general/BidTimer';
import DateFormat from '@/components/general/DateFormat';
import i18next from 'i18next';
import React from 'react';

type Props = {
    hasAuction: boolean;
    auctionOver: boolean;
    endTime: Date | undefined;
    auction: Auction | undefined;
};

const PBBidDetails = ({ hasAuction, auction, auctionOver, endTime }: Props) => {
    if (auction?.type !== Auction.TypeEnum.Auction) {
        return null;
    }
    let deadlineText: string = i18next.t('item-text.current-bid-text.bid-deadline');
    switch (auction?.status) {
        case Auction.StatusEnum.Extended:
            deadlineText = i18next.t('item-text.current-bid-text.bid-deadline-extended');
            break;
        case Auction.StatusEnum.Blind:
            deadlineText = i18next.t('item-text.current-bid-text.bid-deadline-blind');
            break;
        default:
            break;
    }
    return (
        <div className="">
            {hasAuction && !auctionOver &&
                <div
                    className="text-md text-blue9 font-[500] mt-[20px] pt-[20px] border-t-[1px]">
                    <span className="text-[12px] text-grey15 justify-start">
                        {deadlineText}
                    </span>

                </div>
            }

            <div className="flex justify-between items-center ">
                {endTime && (
                    <span className="flex items-center text-[18px] text-black font-[500]">
                        <span className=""><BidTimer dueDate={endTime} /></span>
                    </span>
                )}
                {endTime && (
                    <span className="flex items-center justify-start  text-grey15 text-[14px] font-[500]">
                        <span className=""><DateFormat date={endTime} customMask="mm/dd h:MM TT" /></span>
                    </span>
                )}
            </div>
        </div>
    );
};

export default PBBidDetails;
